/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Business division values for Freewheel ad calls
 * Used in site section ID (csid) construction for ad targeting.
 * Determined by domain check (isPPlus()).
 *
 * @example
 * // Used in AbstractFreewheelClass.getBusinessDivision():
 * const division = this.isPPlus()
 *   ? FreewheelBusinessDivision.STREAMING
 *   : FreewheelBusinessDivision.VCBS;
 *
 * @see {@link AbstractFreewheelClass.createSiteSectionId}
 */
export enum FreewheelBusinessDivision {
	/**
	 * @description Paramount Plus streaming division
	 */
	STREAMING = 'streaming',

	/**
	 * @description ViacomCBS division (CBS, Showtime, etc.)
	 */
	VCBS = 'vcbs',
}